package one.healthium.health_tools.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.black50
import one.healthium.ui.compose.theme.white10
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
internal fun BaseLogControl(
    modifier: Modifier = Modifier.Companion,
    containerColor: Color,
    icon: DrawableResource,
    button: String? = null,
    onClick: () -> Unit = {},
    content: @Composable RowScope.() -> Unit,
) {
    Surface(
        modifier = modifier.fillMaxWidth(),
        color = containerColor,
        shape = AppTheme.shapes.large,
        onClick = onClick,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(7.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            Spacer(Modifier.width(5.dp))
            Box(
                modifier = Modifier
                    .padding(vertical = 2.dp)
                    .size(36.dp)
                    .background(white10, CircleShape),
                contentAlignment = Alignment.Center,
            ) {
                Icon(
                    painter = painterResource(icon),
                    tint = black50,
                    contentDescription = null,
                )
            }
            Spacer(Modifier.width(12.dp))
            content()
            Spacer(Modifier.width(8.dp))
            if (button != null) {
                LogControlButton(button, onClick)
            }
        }
    }
}

@Composable
private fun LogControlButton(
    title: String,
    onClick: () -> Unit,
) {
    Surface(
        modifier = Modifier.height(40.dp),
        color = AppTheme.colors.secondary,
        shape = AppTheme.shapes.large,
        onClick = onClick,
    ) {
        Box(
            modifier = Modifier.padding(horizontal = 12.dp),
            contentAlignment = Alignment.Center,
        ) {
            Text(
                text = title,
                style = AppTheme.textStyles.secondary_14_600,
                color = AppTheme.colors.onSecondary,
            )
        }
    }
}